export default "__VITE_ASSET__wJ3alsoY__"